import { Link } from "@tanstack/react-router"
import { Button } from "toptaal-shared"
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - SVG import
import NotFound from "../assets/NotFound.svg"

export function NotFoundScreen() {
  return (
    <>
      <img
        src={NotFound}
        alt="Pagina niet gevonden"
        className="w-full h-screen object-cover absolute top-0 left-0"
      />
      <div className="relative z-10 flex flex-col justify-start px-4 w-full ">
        <p className="text-2xl sm:text-3xl md:text-4xl font-extrabold">404</p>

        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black !font-mulish uppercase mb-4 mt-2">
          De weg <br className="hidden sm:block" /> kwijt
        </h1>

        <p className="mt-4 text-base sm:text-lg max-w-md">
          Oeps! We kunnen de pagina die je probeert te zoeken niet vinden. Ga
          terug naar home om verder te gaan.
        </p>

        <Link to="/" replace>
          <Button className="mt-6 w-fit">Terug naar home</Button>
        </Link>
      </div>
    </>
  )
}
